export default "/images/d4edad9e3282fd352e915029079055f3.avif";